export default class Navigation {
    constructor($header) {
        this.$header = $header;
        this.$toggle = $header.querySelector('[data-navbar-toggle]');
        this.$collapse = $header.querySelector('[data-navbar-collapse]');
        this.$dropdownToggles = Array.from($header.querySelectorAll('[data-dropdown-toggle]'));
        this.desktopQuery = window.matchMedia('(min-width: 992px)');
        this.lastScrollTop = window.scrollY || 0;
        this.fixedHeaderState = null;

        this.initCollapse();
        this.initDropdowns();
        this.initResponsiveReset();
        this.initFixedHeader();
    }

    /* -- INIT -- */

    initCollapse() {
        if (!this.$toggle || !this.$collapse) {
            return;
        }

        this.$toggle.addEventListener('click', () => {
            if (this.$collapse.classList.contains('in')) {
                this.closeCollapse();
                return;
            }

            this.openCollapse();
        });
    }

    initDropdowns() {
        this.$dropdownToggles.forEach(($toggle) => {
            $toggle.addEventListener('click', (event) => {
                if (this.desktopQuery.matches) {
                    return;
                }

                const $item = $toggle.closest('[data-dropdown-item]');
                if (!$item) {
                    return;
                }

                event.preventDefault();

                const isOpen = $item.classList.contains('open');
                this.closeDropdowns();

                if (!isOpen) {
                    $item.classList.add('open');
                    $toggle.setAttribute('aria-expanded', 'true');
                }
            });

            $toggle.addEventListener('keydown', (event) => {
                if (event.key !== 'Enter' && event.key !== ' ') {
                    return;
                }

                if (this.desktopQuery.matches) {
                    return;
                }

                event.preventDefault();
                $toggle.click();
            });
        });
    }

    initResponsiveReset() {
        const handleDesktopChange = (event) => {
            if (!event.matches) {
                return;
            }

            this.closeCollapse();
            this.closeDropdowns();
        };

        if (typeof this.desktopQuery.addEventListener === 'function') {
            this.desktopQuery.addEventListener('change', handleDesktopChange);
            return;
        }

        this.desktopQuery.addListener(handleDesktopChange);
    }

    initFixedHeader() {
        window.addEventListener('scroll', () => this.handleScroll(), { passive: true });
        this.handleScroll();
    }

    /* -- COLLAPSE -- */

    openCollapse() {
        if (!this.$toggle || !this.$collapse) {
            return;
        }

        this.$collapse.classList.add('in');
        this.$toggle.classList.remove('collapsed');
        this.$toggle.setAttribute('aria-expanded', 'true');
    }

    closeCollapse() {
        if (!this.$toggle || !this.$collapse) {
            return;
        }

        this.$collapse.classList.remove('in');
        this.$toggle.classList.add('collapsed');
        this.$toggle.setAttribute('aria-expanded', 'false');
        this.closeDropdowns();
    }

    closeDropdowns() {
        this.$header.querySelectorAll('[data-dropdown-item].open').forEach(($item) => {
            $item.classList.remove('open');
        });

        this.$dropdownToggles.forEach(($toggle) => {
            $toggle.setAttribute('aria-expanded', 'false');
        });
    }

    /* -- FIXED HEADER -- */

    handleScroll() {
        const scrolled = window.pageYOffset || document.documentElement.scrollTop || 0;
        const $body = document.body;
        let nextState = null;

        if (scrolled > 250) {
            nextState = 'bottom';
        } else if (scrolled > 130) {
            nextState = 'top';
        }

        if (nextState !== this.fixedHeaderState) {
            $body.classList.toggle('header-fixed-top', nextState === 'top');
            $body.classList.toggle('header-fixed-bottom', nextState === 'bottom');
            this.fixedHeaderState = nextState;
        }

        this.lastScrollTop = Math.max(scrolled, 0);
    }
}
